<template>
  <div class="topForm upload">
    <vxe-toolbar size="mini">
      <template v-slot:buttons>
        <div v-if="printShow">
          <vxe-button
            size="medium"
            type="primary"
            class="vxe-btn-save"
            icon="el-icon-download"
            @click="print(1)"
            >打印</vxe-button
          >
          <vxe-button
            size="medium"
            type="primary"
            class="vxe-btn-save"
            icon="el-icon-download"
            @click="print(2)"
            >下载</vxe-button
          >
        </div>
        <div v-else>
          <!-- 单个保存显示 合作伙伴 -->
          <div v-if="!showSaveMain">
            <template v-if="cooperationList">
              <vxe-button
                v-if="show"
                size="large"
                type="primary"
                class="vxe-btn-delete"
                @click="removeSelected()"
                >{{ $t('upload.delBtn') }}</vxe-button
              >
            </template>
            <template v-else>
              <vxe-button
                v-if="show"
                size="medium"
                type="primary"
                class="vxe-btn-delete"
                icon="el-icon-delete"
                @click="removeSelected()"
                >{{ $t('upload.delBtn') }}</vxe-button
              >
            </template>
            <vxe-button
              v-if="!show"
              size="medium"
              type="primary"
              class="vxe-btn-save"
              icon="el-icon-download"
              @click="downLoadSelected()"
              >{{ $t('upload.downLoadBtn') }}</vxe-button
            >
            <div class="uploadBtn" v-if="show">
              <template v-if="useDialog">
                <vxe-button
                  size="medium"
                  type="primary"
                  class="vxe-btn-save"
                  icon="el-icon-upload"
                  @click="openDialog()"
                  >{{ $t('upload.uploadBtn') }}</vxe-button
                >
              </template>
              <template v-else-if="!uploadDialogType">
                <el-upload
                  class="upload-demo"
                  :action="actionUrl"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :before-remove="beforeRemove"
                  :data="{ access_token: userInfo.userInfo.access_token, path: filePath }"
                  multiple
                  :on-exceed="handleExceed"
                  :on-progress="handleProgress"
                  :on-success="handleSuccess"
                  :show-file-list="false"
                >
                  <div v-if="cooperationList">
                    <vxe-button size="large" type="primary" class="vxe-btn-save">{{
                      $t('upload.uploadBtn')
                    }}</vxe-button>
                  </div>
                  <div v-else>
                    <vxe-button
                      size="medium"
                      type="primary"
                      class="vxe-btn-save"
                      icon="el-icon-upload"
                      >{{ $t('upload.uploadBtn') }}</vxe-button
                    >
                  </div>
                  <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
              </template>
              <template v-else>
                <vxe-button
                  size="medium"
                  type="primary"
                  class="vxe-btn-save"
                  icon="el-icon-upload"
                  @click="openDialog()"
                  >{{ $t('upload.uploadBtn') }}</vxe-button
                >
              </template>
            </div>
          </div>
          <div v-else>
            <vxe-button
              size="medium"
              type="primary"
              class="vxe-btn-delete"
              icon="el-icon-delete"
              @click="removeSelected()"
              >{{ $t('upload.delBtn') }}</vxe-button
            >
            <vxe-button @click="handleSave()" type="primary" size="medium" class="vxe-btn-save">{{
              $t('cooperation.buttons.save')
            }}</vxe-button>
            <div class="uploadBtn">
              <template v-if="!uploadDialogType">
                <el-upload
                  class="upload-demo"
                  :action="actionUrl"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :before-remove="beforeRemove"
                  :data="{ access_token: userInfo.userInfo.access_token, path: filePath }"
                  multiple
                  :on-exceed="handleExceed"
                  :on-progress="handleProgress"
                  :on-success="handleSuccess"
                >
                  <vxe-button
                    size="medium"
                    type="primary"
                    class="vxe-btn-save"
                    icon="el-icon-upload"
                    >{{ $t('upload.uploadBtn') }}</vxe-button
                  >
                  <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
              </template>
              <template v-else>
                <vxe-button
                  size="medium"
                  type="primary"
                  class="vxe-btn-save"
                  icon="el-icon-upload"
                  @click="openDialog()"
                  >{{ $t('upload.uploadBtn') }}</vxe-button
                >
              </template>
            </div>
          </div>
        </div>
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      show-overflow
      resizable
      ref="xGrid"
      class="vxe-table-element"
      size="mini"
      :align="cooperationList ? 'center' : 'left'"
      :auto-resize="true"
      :data="tableData"
      :toolbar="tableToolbar"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      @cell-dblclick="handleDblclick"
      @radio-change="handleRadioChange"
    >
      <vxe-table-column v-if="printShow" type="radio" width="50" fixed="left"></vxe-table-column>
      <vxe-table-column v-else type="checkbox" width="50" fixed="left"></vxe-table-column>
      <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
      <!--<vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>-->
      <vxe-table-column
        v-for="(item, index) in printShow ? columnListPrint : columnList"
        :key="index"
        :fixed="item.fixed"
        :sortable="item.sortable"
        :field="item.prop"
        :title="item.label"
      >
        <template v-slot="{ row }">
          <span v-if="item.prop === 'fileType'">{{ format(row[item.prop]) }}</span>
          <span v-else>{{ row[item.prop] }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>

    <el-dialog :visible.sync="dialogVisible" width="30%">
      <div class="dialog-body">
        <div class="function-item">
          <el-form ref="form" :model="uploadForm" label-width="120px">
            <el-form-item label="选择上传文件类型">
              <el-select v-model="uploadForm.fileType" placeholder="请选择活动区域">
                <el-option
                  v-for="(item, index) in fileTypeList"
                  :label="item.label"
                  :value="item.value"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="actionUrl"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :data="{ access_token: userInfo.userInfo.access_token, path: filePath }"
            multiple
            :auto-upload="false"
            :on-exceed="handleExceed"
            :on-progress="handleProgress"
            :on-success="handleSuccess"
            :on-change="uploadChange"
          >
            <vxe-button size="medium" type="primary" class="vxe-btn-save" icon="el-icon-upload"
              >选择文件</vxe-button
            >
          </el-upload>
        </div>
        <div class="upload-file-list-wrap" v-show="viewFileList.length > 0">
          <div class="file-label">{{ format(uploadForm.fileType) }}</div>
          <ul class="upload-file-list">
            <li
              v-for="(item, index) in viewFileList"
              :key="index"
              :title="item.name"
              @click="deleteFile(item)"
            >
              {{ item.name }}
              <a href="javascript:;" @click="deleteFile(item)">删除</a>
            </li>
          </ul>
        </div>
      </div>
      <p slot="footer">
        <el-button class="dialog-btn cancel-dialog" type="primary" @click="cancelSelect"
          >取消</el-button
        >
        <el-button class="dialog-btn confirm-dialog" type="primary" @click="confirmUpload"
          >确认上传</el-button
        >
      </p>
    </el-dialog>
  </div>
</template>
<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/dataBase';
  import { dateTimeFormat } from '@/filters/index';
  import { findFileType } from '@/common/js/upload';
  import baseUrl from '@/common/config';
  export default {
    name: 'upload',
    props: {
      //是否显示上传和删除按钮
      isShow: {
        type: Boolean,
        default: () => true,
      },
      //默认值
      tableData: {
        type: Array,
        default: () => [],
      },
      defaultPath: {
        type: String,
        default: 'scm/maindata',
      },
      //显示打印
      printShow: {
        type: Boolean,
        default: () => false,
      },
      cooperationList: {
        type: Boolean,
        default: () => false,
      },
      //是否显示保存按钮
      showSave: {
        type: Boolean,
        default: () => false,
      },
      useDialog: {
        type: Boolean,
        default: () => false,
      },
      dbClickDownload: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      let newDate = dateTimeFormat(new Date());
      return {
        dialogVisible: false,
        uploadForm: {
          fileType: null,
        },
        viewFileList: [],
        fileTypeList: [],
        uploadDialogType: null, //当前交易类型
        uploadTableData: this.tableData,
        multipleSelection: [], //存放选中的值
        todayDate: newDate,
        actionUrl: '',
        show: this.isShow,
        filePath: this.defaultPath,
        showSaveMain: this.showSave,
        tableToolbar: {
          id: 'toolbar',
          // refresh: true,
          // setting: {
          //   storage: true
          // }
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),

      //表格显示字段
      columnList() {
        if (this.cooperationList) {
          return [
            {
              prop: 'attachmentName',
              label: this.$t('upload.attachmentName'),
              sortable: true,
            },
            { prop: 'createBy', label: this.$t('upload.uploader') },
            { prop: 'gmtCreate', label: this.$t('upload.uploadDate') },
          ];
        }

        return [
          {
            prop: 'attachmentName',
            label: this.$t('upload.attachmentName'),
            sortable: true,
          },
          // {
          //   prop: 'fileType',
          //   label: '附件类型',
          // },
          { prop: 'createBy', label: this.$t('upload.uploader') },
          { prop: 'gmtCreate', label: this.$t('upload.uploadDate') },
        ];
      },
      columnListPrint() {
        return [
          {
            prop: 'attachmentName',
            label: this.$t('upload.attachmentName'),
            sortable: true,
          },
        ];
      },
    },
    mounted() {
      this.actionUrl = baseUrl + API.OSS_UPLOAD_API;
      // this.actionUrl = 'http://192.168.60.168:8088'  + API.OSS_UPLOAD_API;
      this.loadDict();
    },
    methods: {
      //判断是否上传了必填附件
      async checkRequired() {
        if (this.uploadTableData.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('请上传附件'),
            type: 'error',
          });
          return false;
        }
        let result = false;
        let tips = [];
        await this.$axios
          .post('/maindata/dict/getAllDictMap', { dictType: this.uploadDialogType + '_FILEREQ' })
          .then((res) => {
            let requiredFileList = res.data.data;
            for (let key in requiredFileList) {
              if (!requiredFileList[key].enable) continue;
              for (let j = 0; j < this.uploadTableData.length; j++) {
                if (this.uploadTableData[j].fileType === requiredFileList[key].value) {
                  result = true;
                }
              }
              if (!result) {
                tips.push(requiredFileList[key].label);
              }
              result = false;
            }
          });
        if (tips.length > 0) {
          this.$message({
            showClose: true,
            message: '请上传' + tips.join(',') + '附件',
            type: 'error',
          });
          return false;
        } else {
          return true;
        }
      },
      async loadDict() {
        this.loading.startLoading();
        findFileType().then((res) => {
          this.uploadDialogType = res.type; //当前交易类型
          for (let key in res.fileList) {
            this.fileTypeList.push(res.fileList[key]);
          }
          this.uploadForm.fileType = this.fileTypeList[0]?.value;
          this.loading.endLoading();
        });
      },
      //设置单选选中
      setRadioRow(val) {
        this.$refs.xGrid.setRadioRow(val);
        this.multipleSelection = [this.$refs.xGrid.getRadioRecord()];
      },
      //返回数据
      getVal() {
        return JSON.stringify(this.tableData);
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(
          `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
            files.length + fileList.length
          } 个文件`
        );
      },
      beforeRemove(file) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      // 上传时
      handleProgress(event, file, fileList) {
        console.log(event, file, fileList, '文件上传时');
        this.loading.startLoading('正在上传中....');
      },
      //上传成功
      handleSuccess(res, file) {
        this.loading.endLoading();
        if (res.code === 0) {
          let obj = {
            attachmentName: file.name,
            createBy: this.userInfo.userInfo.userName,
            gmtCreate: dateTimeFormat(new Date()),
            attachmentPath: res.data.attachmentPath,
            attachmentKey: res.data.attachmentKey,
            dataType: this.uploadDialogType,
            fileType: this.uploadForm.fileType,
          };
          this.uploadTableData.push(obj);
          this.$refs.xGrid.reloadData(this.uploadTableData);
          this.$emit('upload', this.uploadTableData);
          //console.log(file,test)
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row.selection;
      },
      //radio表格选中事件
      handleRadioChange(val) {
        // this.$emit("handleSelectionChange", [val.row]);
        this.multipleSelection = [val.row];
      },
      //删除
      removeSelected() {
        let _self = this;
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('upload.noSelectDel'),
            type: 'error',
          });
        } else {
          this.$confirmAction()
            .then(() => {
              this.$refs['xGrid'].removeSelecteds();
              // this.uploadTableData = this.uploadTableData.filter((item) => {
              //   let flag = true;
              //   this.multipleSelection.map((select) => {
              //     if (item._XID == select._XID) {
              //       flag = false;
              //     }
              //   });
              //   return flag;
              // });
              const xIDList = this.multipleSelection.map((item) => item._XID);
              this.uploadTableData = this.uploadTableData.filter(
                (item) => !xIDList.includes(item._XID)
              );

              const keyList = this.multipleSelection.map((item) => item.attachmentKey);
              this.uploadTableData = this.uploadTableData.filter(
                (item) => !keyList.includes(item.attachmentKey)
              );
              //如果操作成功，直接返回列表
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              _self.$emit('upload', this.uploadTableData);
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
      },
      //批量下载
      downLoadSelected() {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('upload.noSelectDownLoad'),
            type: 'error',
          });
        } else {
          let params = {
            keyList: this.multipleSelection.map((it) => it.attachmentKey),
          };
          this.$axios.post(API.DOWNLOAD_FILE, params).then((res) => {
            if (res.data.code == 0) {
              res.data.data.map((it) => {
                this.downloadFile(it);
              });
            }
          });
        }
      },
      //多个文件下载
      downloadFile(url) {
        window.open(url, '_blank');
      },
      //双击下载文档
      handleDblclick(data) {
        // console.log(data);
        if (this.dbClickDownload) {
          // window.location.href = data.row.attachmentPath;
          const a = document.createElement('a');
          a.href = data.row.attachmentPath;
          a.target = '_blank';
          a.click();
        }
      },
      //打印
      print(type) {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message:
              type == 1 ? this.$t('upload.noSelectPrint') : this.$t('upload.noSelectDownLoad'),
            type: 'error',
          });
        } else {
          this.$emit('uploadPrint', this.multipleSelection[0], type);
        }
      },
      handleSave() {
        this.$emit('handleSave');
      },
      uploadChange(file, fileList) {
        console.log('uploadChange');
        this.viewFileList = fileList;
      },
      deleteFile(item) {
        const index = this.$refs.upload.uploadFiles.findIndex((e) => e.uid === item.uid);
        this.$refs.upload.uploadFiles.splice(index, 1);
      },
      cancelSelect() {
        this.$refs.upload.clearFiles();
        this.dialogVisible = false;
      },
      confirmUpload() {
        if (this.viewFileList.length <= 0) {
          this.$message({
            showClose: true,
            message: '请选择文件',
            type: 'error',
          });
          return;
        }
        this.$refs.upload.submit();
        this.dialogVisible = false;
      },
      openDialog() {
        this.viewFileList = [];
        this.dialogVisible = true;
        if (this.$refs.upload) this.$refs.upload.clearFiles();
      },
      format(item) {
        let fileName = '-';
        this.fileTypeList.forEach((val) => {
          if (val.value === item) {
            fileName = val.label;
          }
        });
        return fileName;
      },
    },
    watch: {
      tableData() {
        this.uploadTableData = this.tableData;
      },
      isShow() {
        this.show = this.isShow;
      },
      showSave() {
        this.showSaveMain = this.showSave;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .uploadBtn {
    float: left;
    padding-right: 16px;
  }
  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
    .function-item {
      display: flex;
      .el-form {
        padding-right: 20px;
      }
    }
    .upload-file-list-wrap {
      display: flex;
      .file-label {
        width: 110px;
        text-align: right;
        font-size: 12px;
      }
      .upload-file-list {
        padding-left: 20px;
        list-style: none;
        a {
          padding-left: 10px;
        }
      }
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
</style>
